import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./decisionList.css";
import Table from "../../core/common/dataTable/index";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AxiosError } from "axios";
// import CreateDecisionModal from "./createDecisionModal";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";
import { my_routes } from "../router/all_routes";
import {
  generateDiplomeDuplicata,
  getAllDiplomesByDecision,
  getDecisionById,
  getDecisionParameter,
  getDiplomeFile,
} from "../../api/diplome";
import { toast } from "sonner";
import ValidationModal from "./validationModal";

// ─── Boutons protégés ────────────────────────────────────────────────────────

const ProtectedBtnCreateDuplicata = withPermission(
  (props: any) => (
    <div className="dropdown">
      <Link
        to="#"
        className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center p-0"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{ borderColor: "rgba(33, 37, 41, 0.5)" }}
      >
        <i className="ti ti-dots-vertical fs-14" />
      </Link>
      <ul className="dropdown-menu dropdown-menu-right p-3">
        {/* Voir le détail */}
        <li>
          <button
            className="dropdown-item rounded-1"
            // to={`/decision-details/${record.id}`}
            onClick={() => props.createDuplicataAlert(props.record.id)}
          >
            <i className="ti ti-eye me-2" />
            Créer un duplicata
          </button>
        </li>
        {/* Supprimer (protégé) */}
        {/* <ProtectedBtnDeleteDecision
          showConfirmationAlert={showConfirmationAlert}
          record={record}
        /> */}
      </ul>
    </div>
  ),
  [buildPermission(Resource.DIPLOME, Action.CREATE)],
  "masquer",
);

const getDiplomeStatutBadge = (statut?: string) => {
  switch (statut) {
    case "Généré":
      return { className: "bg-soft-success", label: "Généré", icon: "✅" };
    case "En Attente":
      return { className: "bg-soft-warning", label: "En Attente", icon: "⏳" };
    case "En cours de validation":
      return {
        className: "bg-soft-info",
        label: "En cours de validation",
        icon: "🕒",
      };
    case "Validé":
      return { className: "bg-soft-success", label: "Validé", icon: "✅" };
    case "Annulé":
      return { className: "bg-soft-danger", label: "Annulé", icon: "❌" };
    default:
      return {
        className: "bg-soft-secondary",
        label: statut || "Inconnu",
        icon: "•",
      };
  }
};

// ─── Composant principal ──────────────────────────────────────────────────────

const DiplomeList = () => {
  const route = my_routes;

  const [diplomeList, setDiplomeList] = useState<any>(null);
  const [decisionDetail, setDecisionDetail] = useState<any>(null);
  const [decisionParameter, setDecisionParameter] = useState<any>(null);
  const [allStudentDecisions, setAllStudentDecisions] = useState<any>(null);
  const [loadingDuplicataId, setLoadingDuplicataId] = useState<string | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedValidationLevel, setSelectedValidationLevel] =
    useState<string>("");
  const [showValidationModal, setShowValidationModal] = useState(false);

  // === Paramètres d'URL ===
  const { id } = useParams(); // On récupère l'id de l'URL

  const MySwal = withReactContent(Swal);

  // ── Colonnes du tableau ──────────────────────────────────────────────────

  const columns = [
    {
      title: "N° Diplôme",
      dataIndex: "numero_diplome",
      sorter: (a: any, b: any) =>
        (a?.number || "").localeCompare(b?.number || ""),
      render: (_: unknown, record: any) => (
        <span
          className="fw-medium"
          style={{
            fontFamily: "monospace",
            fontSize: 13,
            background: "#eef4ff",
            color: "#1d4ed8",
            padding: "4px 10px",
            borderRadius: 999,
            border: "1px solid #dbe7ff",
            letterSpacing: "0.03em",
          }}
        >
          {record?.number || "--"}
        </span>
      ),
    },
    {
      title: "Nom et Prénom",
      dataIndex: "nomPrenom",
      sorter: (a: any, b: any) =>
        `${a?.ParcoursStudent?.StudentProfil?.firstname || ""} ${a?.ParcoursStudent?.StudentProfil?.lastname || ""}`.localeCompare(
          `${b?.ParcoursStudent?.StudentProfil?.firstname || ""} ${b?.ParcoursStudent?.StudentProfil?.lastname || ""}`,
        ),
      render: (_: unknown, record: any) => (
        <span style={{ fontSize: 13 }} className="fw-medium">
          {record?.student?.prenom || record?.student?.nom
            ? `${record?.student?.prenom} ${record?.student?.nom}`
            : "--"}
        </span>
      ),
    },
    {
      title: "Classe / Parcours",
      dataIndex: "classeParcours",
      sorter: (a: any, b: any) =>
        `${a?.ParcoursStudent?.Parcour?.Cycle?.label || ""} ${a?.ParcoursStudent?.Parcour?.title || ""} ${a?.Class?.Level?.abbreviation || ""} ${a?.Class?.label || ""}`.localeCompare(
          `${b?.ParcoursStudent?.Parcour?.Cycle?.label || ""} ${b?.ParcoursStudent?.Parcour?.title || ""} ${b?.Class?.Level?.abbreviation || ""} ${b?.Class?.label || ""}`,
        ),
      render: (_: unknown, record: any) => (
        <span style={{ fontSize: 13 }} className="fw-bold">
          {record?.Parcour?.label_cycle || "--"} -{" "}
          {record?.Parcour?.titre || "--"}
          <span className="d-block fw-medium" style={{ fontSize: 12 }}>
            {record?.last_registration?.abb_level || "--"}{" "}
            {record?.last_registration?.label_classe || "--"}
          </span>
        </span>
      ),
    },
    {
      title: "Mention",
      dataIndex: "mention",
      sorter: (a: any, b: any) =>
        Number(a?.noteParcours || 0) - Number(b?.noteParcours || 0),
      render: (_: unknown, record: any) => (
        <span style={{ fontSize: 13 }} className="fw-medium">
          {record?.noteParcours || "--"} - {record?.MentionCycle || "--"}
        </span>
      ),
    },
    {
      title: "Statut",
      dataIndex: "statut",
      sorter: (a: any, b: any) =>
        (a?.statut || "").localeCompare(b?.statut || ""),
      render: (_: unknown, record: any) => {
        const statutBadge = getDiplomeStatutBadge(record?.statut);

        return (
          <span
            className={`pt-1 pb-1 badge ${statutBadge.className}`}
            style={{ fontSize: 12 }}
          >
            {statutBadge.icon} {statutBadge.label}
          </span>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: unknown, record: any) => (
        <div className="d-flex align-items-center">
          <Link
            to={`/diplomes/${id}/${record?.id}`}
            title="Voir"
            className="btn btn-light btn-icon btn-sm text-dark me-2"
            style={{ borderColor: "rgba(33, 37, 41, 0.5)" }}
          >
            <i className="ti ti-eye fs-14" />
          </Link>
          {record?.Duplicata?.id && (
            <button
              onClick={() => fetchDuplicataFile(record?.Duplicata?.id)}
              title="Voir le Duplicata"
              className="btn btn-light btn-icon btn-sm text-dark me-2"
              style={{ borderColor: "rgba(33, 37, 41, 0.5)" }}
            >
              {loadingDuplicataId === record?.Duplicata?.id ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm ms-0"
                    role="status"
                    aria-hidden="true"
                  />
                </>
              ) : (
                <>
                  <i className="ti ti-files fs-14" />
                </>
              )}
            </button>
          )}
          {record?.statut === "Généré" && !record?.Duplicata?.id && (
            <ProtectedBtnCreateDuplicata
              record={record}
              createDuplicataAlert={createDuplicataAlert}
            />
          )}
        </div>
      ),
    },
  ];

  const reloadData = () => setRefreshKey((prev) => prev + 1);

  // ── Chargement des données ───────────────────────────────────────────────

  const fetchDecisionDetails = async () => {
    try {
      setIsLoading(true);

      const response = await getDecisionById(id);
      const decisionData = response.data || [];
      // console.log("Données brutes reçues : ", decisionData);

      setDecisionDetail(decisionData);
      setAllStudentDecisions(decisionData.DecisionStudents || []);
    } catch (error: any) {
      // console.log("erreur de chargement de la décision : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );

      // Option: reset la décision en cas d'erreur
      setDecisionDetail(null);
    } finally {
      setIsLoading(false); //Les données ne sont plus en chargement
      setHasLoaded(true); //Les données ont été chargé avec succès
    }
  };

  const fetchDiplomes = async () => {
    try {
      setIsLoading(true);

      const response = await getAllDiplomesByDecision(id);
      const diplomeData = response.data || [];
      // console.log("Diplome brutes reçues : ", response);

      setDiplomeList(diplomeData);
    } catch (error: any) {
      // console.log("erreur de chargement des diplômes : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoading(false);
      setHasLoaded(true);
    }
  };

  const fetchDecisionParameter = async () => {
    try {
      const response = await getDecisionParameter();
      if (!response) {
        // Si aucune année trouvé
        throw new Error("Paramètres introuvable");
      }
      // console.log("Paramètres", response.data)
      setDecisionParameter(response.data.decisionParameter);
    } catch (error: any) {
      // Si erreur (Toast Error)
      toast.error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const createDuplicataAlert = (idDiplome: string) => {
    MySwal.fire({
      title: "Créer un duplicata de ce diplôme ?",
      text: `Veuillez vous assurer de la conformité des informations pour la validation.`,
      showCancelButton: true,
      confirmButtonText: "Créer !",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Création du duplicata en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });

        try {
          await generateDiplomeDuplicata(idDiplome);
          MySwal.fire({
            title: "Création du duplicata terminée !",
            icon: "success",
            confirmButtonText: "OK",
          });
          reloadData();
        } catch (error) {
          const err = error as AxiosError<any>;
          MySwal.fire({
            title: "Erreur",
            text:
              err.response?.data?.message ||
              err.response?.data?.error ||
              "Une erreur est survenue, réessayez plus tard",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const fetchDuplicataFile = async (idDuplicata: string) => {
    const newTab = window.open("", "_blank");

    try {
      if (!newTab) {
        throw new Error(
          "Impossible d'ouvrir un nouvel onglet. Vérifiez le blocage des pop-ups.",
        );
      }

      newTab.opener = null;
      setLoadingDuplicataId(idDuplicata);

      const response = await getDiplomeFile(idDuplicata, "DiplomaDuplicate");
      const duplicataFile = response.data || [];
      // console.log("Données du duplicata reçues : ", duplicataFile);

      const duplicataUrl =
        duplicataFile[0]?.temporarlyUrl || duplicataFile[0]?.temporaryUrl;

      if (!duplicataUrl) {
        throw new Error("Aucun fichier duplicata disponible");
      }

      newTab.location.href = duplicataUrl;
    } catch (error: any) {
      newTab?.close();
      // console.log("erreur de chargement du duplicata : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );

      // Option: reset la décision en cas d'erreur
    } finally {
      setLoadingDuplicataId(null); //Les données ne sont plus en chargement
    }
  };

  useEffect(() => {
    // On attend que id soit défini
    if (!id) return;

    fetchDecisionDetails();
    fetchDecisionParameter();
    fetchDiplomes();
  }, [refreshKey, id]);

  // ── Rendu ────────────────────────────────────────────────────────────────

  if (isLoading) {
    return (
      <div className="page-wrapper">
        <div
          className="content d-flex align-items-center justify-content-center"
          style={{ minHeight: "calc(100vh - 120px)" }}
        >
          <div className="card">
            <div className="card-body py-5 text-center">
              <span
                className="spinner-border text-primary me-2"
                role="status"
              />
              Chargement des diplômes de la décision...
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!decisionDetail || decisionDetail.length === 0) {
    return (
      <div className="alert alert-info">
        Aucun diplôme généré pour cette décision.
      </div>
    );
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content decision-list-page">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">
                Diplôme de la décision #{decisionDetail?.number}
              </h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={route.decisionList}>Diplômes</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={`/decision-details/${decisionDetail?.id}`}>
                      Décisions #{decisionDetail?.number}
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Liste des diplômés
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row g-3">
            <div className="card col-12">
              <div className="card-body d-flex align-items-center justify-content-between p-3 pb-0">
                <div>
                  <h3 className=" mb-1">
                    {" "}
                    Diplôme Genere - Décision {decisionDetail?.number}{" "}
                  </h3>
                  <p className="d-flex align-items-center mb-2 text-muted">
                    <i className="ti ti-calendar-bolt me-1 mb-1" />
                    Année :{" "}
                    <span className="text-dark ms-1">
                      {" "}
                      Session de Juin{" "}
                      {new Date(decisionDetail?.createdAt).getFullYear()}
                    </span>
                    <i className="ti ti-user ms-2 me-1 mb-1" />{" "}
                    <span className="text-dark ms-1">
                      {" "}
                      {decisionDetail?.total_students} Étudiant(s)
                    </span>
                  </p>
                </div>
                <div className="d-flex align-items-center align-self-center">
                  <span className="badge badge-success d-inline-flex align-items-center">
                    <i className={`ti ti-check me-1`} />
                    Diplôme Généré
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* ── Tableau ── */}
          <div
            className={`card ${decisionDetail?.statut == "Brouillon" || "mt-3"}`}
          >
            <div className="decision-table-header card-header d-flex align-items-center justify-content-between flex-wrap">
              <div>
                <h4 className="mb-1">Étudiants Diplômés</h4>
                <p className="mb-0">
                  Une lecture plus claire des statuts, validations et cohortes.
                </p>
              </div>
            </div>
            <div className=" card-body p-0 py-3">
              {isLoading || !hasLoaded ? (
                <div className="text-center py-4">
                  <div className="spinner-border" role="status" />
                  <span className="visually-hidden">
                    Chargement des étudiants...
                  </span>
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={diplomeList}
                  Selection={true}
                  // onRow={(record: DecisionTable) => ({
                  //   onClick: () => navigate(`/diplomes/decisions/${record.id}`),
                  //   style: { cursor: "pointer" },
                  // })}
                />
              )}
            </div>
          </div>

          {/* ── Modal de validation ── */}
          <ValidationModal
            show={showValidationModal}
            idDecision={id}
            validationLevel={selectedValidationLevel}
            onClose={() => setShowValidationModal(false)}
            onSaved={reloadData}
          />
        </div>
      </div>
    </>
  );
};

export default DiplomeList;
